// eslint-disable-next-line max-len
import { useDataModel } from '@thd-nucleus/data-sources';
import { hasPropertyEqualto } from '../utils/has-property-equal-to';

const CARPET_CLASS_NUM = 15;
const CARPET_SUBCLASS_NUM = 16;
const MAINTENANCE_SERVICE_TYPE = 'Maintenance';

const hasProtectionPlanData = (data) => {
  return data?.protectionPlan?.itemId && data?.protectionPlan?.price && data?.protectionPlan?.termLength;
};

const hasInstallationData = (data) => {
  const { installSkus = [] } = data?.serviceAddOns?.attachLabor || {};
  const { serviceType = '', installRetailPrice = {} } = (installSkus?.length && installSkus?.[0]) || {};
  return serviceType && serviceType !== MAINTENANCE_SERVICE_TYPE && installRetailPrice?.price;
};

const useProductAddOnsFlow = ({ itemId, storeId }) => {
  const optionsForProduct = {
    variables: {
      itemId,
      storeId
    },
    ssr: false,
  };
  const { data: productData, loading: pLoading } = useDataModel('clientOnlyProduct', optionsForProduct);

  const {
    protectionPlanSku = false,
    hasServiceAddOns = false,
  } = productData?.product?.info || {};

  const inStoreAssemblyAvailable = productData?.product?.fulfillment?.inStoreAssemblyEligible;
  const { value } = productData?.product?.pricing || {};
  const { discontinued } = productData?.product?.availabilityType || {};

  const optionsForProtectionPlan = {
    variables: {
      protectionPlanParentId: protectionPlanSku,
      storeId,
      price: value || 0.00,
    },
    ssr: false,
    skip: !protectionPlanSku,
  };
  const { data: protectionPlanData, loading: ppLoading } = useDataModel('protectionPlan', optionsForProtectionPlan);

  const optionsForServiceAddOns = {
    variables: {
      itemId,
      storeId,
    },
    ssr: false,
    skip: !hasServiceAddOns
  };

  const { data: serviceAddOnsData, loading: sLoading } = useDataModel('serviceAddOns', optionsForServiceAddOns);
  const isInstallationSku = !discontinued && !!hasInstallationData(serviceAddOnsData);
  const isAssembly = !discontinued && !!serviceAddOnsData?.serviceAddOns?.proReferrals?.[0]?.assemblyCategory;
  const isProReferral = !discontinued
    && !!serviceAddOnsData?.serviceAddOns?.proReferrals?.[0]?.available
    && !isAssembly;
  const isDualPath = !discontinued && !!serviceAddOnsData?.serviceAddOns?.sellFurnishInstall?.dualPathSku;
  const isProtectionPlan = !discontinued && !!protectionPlanSku && hasProtectionPlanData(protectionPlanData);
  const isSAMDualPath = !discontinued && hasPropertyEqualto(
    {
      product: productData?.product,
      productDepartment: 23,
      classNumber: [1, 4, CARPET_CLASS_NUM],
      subClassNumber: [23, 22, 21, 17, 11, 20, 66, CARPET_SUBCLASS_NUM]
    }
  );

  const loading = pLoading || ppLoading || sLoading;
  const data = {
    ...productData,
    ...protectionPlanData,
    ...serviceAddOnsData
  };

  return {
    loading,
    data,
    isProtectionPlan,
    isProReferral,
    isAssembly,
    isDualPath,
    isInstallationSku,
    inStoreAssemblyAvailable,
    isSAMDualPath,
  };
};

export { useProductAddOnsFlow };
